import { ViewIds } from '@ardoq/api-types';
import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { DEFAULT_ARDOQ_I18NLOCALE, I18nLocale, t } from '@ardoq/i18n';
import { NotConnectedError } from './NotConnectedError';
import { EmptyStatesDoqContainer } from './atoms';
import type { OnViewSettingsUpdate } from '@ardoq/data-model';

type NoConnectedComponentsDoqProps = {
  doqType: DoqType;
  viewId: ViewIds;
  includeActions?: boolean;
  onViewSettingsUpdate: OnViewSettingsUpdate;
  i18nLocale?: I18nLocale;
};

const NoConnectedComponentsDoq = ({
  doqType,
  viewId,
  includeActions = true,
  onViewSettingsUpdate,
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
}: NoConnectedComponentsDoqProps) => (
  <EmptyStatesDoqContainer>
    <ResponsiveDoqWithSpeechBubble
      doqType={doqType}
      title={t(
        i18nLocale,
        'graph:noConnectedComponents.title',
        'There is nothing to show'
      )}
      message={
        <NotConnectedError
          i18nLocale={i18nLocale}
          message={t(
            i18nLocale,
            'graph:noConnectedComponents.message',
            'There are no connected components to display here.'
          )}
        />
      }
      buttonLabel={
        includeActions
          ? t(
              i18nLocale,
              'graph:noConnectedComponents.deactivateSetting',
              'Deactivate setting'
            )
          : undefined
      }
      onButtonClick={
        includeActions
          ? () =>
              onViewSettingsUpdate(
                viewId,
                {
                  showOnlyConnectedComponents: false,
                },
                true
              )
          : undefined
      }
    />
  </EmptyStatesDoqContainer>
);
export { NoConnectedComponentsDoq };
